import { ComponentIds } from '@inter-ikea-core/core';
import { OutlinedComponent } from '@inter-ikea-core/core';
import RedOutlineComponent from '../components/RedOutlineComponent';
import { PlannerEcsSystem } from './System';
import { OutlineColor } from '../SceneApi';
/**
 * Marks entity with RedOutlineComponent red
 */
export class RedOutlineSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'RedOutlineSystem', RedOutlineComponent.id);
    }
    onAdd(entity) {
        this.coreApi.scene?.setGlobalOutlineColor(OutlineColor.RED);
        entity.addComponent(new OutlinedComponent());
    }
    onUpdate() { }
    onRemove(entity) {
        entity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
        this.coreApi.entities.getByComponent(RedOutlineComponent.id).length === 0 &&
            this.coreApi.scene?.setGlobalOutlineColor(OutlineColor.BLUE);
    }
}
//# sourceMappingURL=RedOutlineSystem.js.map